import { z } from 'zod';

/** Banco que o usuario pode selecionar como contexto financeiro. */
export const bank = z.object({
  id: z.number().int().positive(),
  name: z.string().min(1),
  code: z.string().nullable(),
});

export type Bank = z.infer<typeof bank>;
